import logo from '@brand/logo-white.svg';
import UiStartupScreen from '@srm/ui/shell/StartupScreen';

// Экран живёт в @srm/ui; логотип — из ассетов Front (тот же путь подставляет плагин startup-screen-html).
const StartupScreen = ({ withinLayout = false }: { withinLayout?: boolean }) => (
    <UiStartupScreen logoSrc={logo} withinLayout={withinLayout} />
);

export default StartupScreen;
